<div class="btn-float">
	<i class="bi bi-file-earmark-plus-fill"></i>
</div>
<div class="dashboard-card list-card">
  <div class="widget-header">
    <h5>
      Student Inquiry List
    </h5>
		<!-- <select class="form-select w-50" [(ngModel)]="inst_id">
				<option value="0">
						Select Institute
				</option>
				@for(inst of institutes; track $index) {
						<option value="{{inst.id}}">{{inst.inst_name}}</option>
				}
		</select> -->
    <button class="btn btn-sm btn-light py-0" data-bs-toggle="modal" data-bs-target="#frmBackdrop" (click)="newClick()">
      +Add New
    </button>
  </div>

	<div class="w-100">
		<table id="orgTable" class="table table-striped w-100">
			<thead>
				<tr>
					<th>#</th>
					<th>Name</th>
					<th>Gender</th>
					<th>Mobile</th>
					<th>City</th>
					<th>Reg. Date</th>
					<th>Status</th>
					<th>Action</th>
				</tr>
			</thead>
			<tbody>
				@for(data of allData; track $index; let idx = $index;) {
				<tr>
					<td>{{idx+1}}.</td>
					<td>
						{{data.iname}}
					</td>
					<td>{{data.gender=='M' ? 'Male' : 'Female'}}</td>
					<td>{{data.mobile_no}}</td>
					<td>{{data.city}}</td>
					<td>{{dataService.ymd2dmy(data?.inq_date?.substr(0,10))}}</td>
					<td>{{dataService.getInqStatus(data.inq_status)}}</td>
					<td>
						<div class="d-flex gap-2">
							<!-- <span style="cursor: pointer;" (click)="checkEligibility(data);" title="Check Eligibility">
								<i class="bi bi-search-heart"></i>
							</span> -->

							<span style="cursor: pointer;" (click)="showInqDetails(data);" data-bs-toggle="offcanvas"
								data-bs-target="#offcanvasRight" title="View Details">
								<i class="bi bi-layout-text-sidebar-reverse"></i>
							</span>
							<span style="cursor: pointer;" title="Follow Ups" data-bs-toggle="offcanvas"
								data-bs-target="#offcanvasRight" title="Follow Ups" (click)="doFollowups(data.id)">
								<i class="bi bi-file-person-fill"></i>
							</span>
							<span style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#frmBackdrop"
								(click)="editClick(data)" title="Modify">
								<i class="bi bi-pencil-square text-success"></i>
							</span>
							<span style="cursor: pointer;" (click)="deleteClick(data.id)" title="Delete">
								<i class="bi bi-trash3-fill text-danger"></i>
							</span>
						</div>
					</td>
				</tr>
				}
			</tbody>
		</table>

		<div class="text-danger" align="center" *ngIf="allData && !allData.length && !loading">
			<i class="bi bi-x-circle"></i> No data available. <span (click)="ngOnInit()">Refresh Data</span>
		</div>
	</div>
</div>

<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel"
	style="width: 500px;">
	<div class="offcanvas-header">
		<h5 class="offcanvas-title" id="offcanvasRightLabel">{{actFor.title}}</h5>
		<button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
	</div>
	<div class="offcanvas-body">
		<div *ngIf="actFor.type=='inqd'">
			<app-inq-view [inqData]="inqData"></app-inq-view>
		</div>
		<div *ngIf="actFor.type=='ufup'">
			<app-follow-ups-form [inq_id]="inq_id" [isEdit]="false"></app-follow-ups-form>
		</div>
	</div>
</div>

<div class="modal fade" id="frmBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
	aria-labelledby="frmBackdropLabel" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="frmBackdropLabel">Inquiry Form</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body" *ngIf="btnClick">
				<app-inq-form [user]="user" [action]="btnClick"></app-inq-form>
			</div>
			<div class="modal-footer">
				<button type="button" class="col-2 btn btn-sm btn-secondary" data-bs-dismiss="modal">Cancel</button>
				<button type="button" class="col-2 btn btn-sm btn-primary" data-bs-dismiss="modal" 
					(click)="btnClick = isEdit ? 'update' : 'save'; reloadData();">
					{{isEdit ? 'Update' : 'Save'}}
				</button>
			</div>
		</div>
	</div>
</div>

